import { render, staticRenderFns } from "./DefinitionDeleteModal.vue?vue&type=template&id=c3ba06ae"
import script from "./DefinitionDeleteModal.vue?vue&type=script&lang=ts"
export * from "./DefinitionDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports